var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cropper t-a-center"},[_c('vueCropper',{ref:"cropper",attrs:{"img":_vm.imgUrl,"autoCrop":true,"fixedNumber":[1, 1],"fixed":false,"canScale":false,"outputType":'png',"fixedBox":false,"outputSize":1,"maxImgSize":3000,"full":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }